import { Alert, Checkbox, Col, Form, Input, Modal, Row, notification } from 'antd';
import Cookies from 'js-cookie';
import { edsResultCheck, localize, parseUrlQuery } from 'mixins/helpers';
import React, { FC, useEffect, useState } from 'react';
import service from '../../../services/account';
import { auth, getDataFromEcp } from '../actions';
import ForgetPassword from './forget-password';
import SignUpUser from './signup-user';
import Signature from '/react4xp/mixins/ui/button-signature';
import Button from '/react4xp/mixins/ui/button/button';
import ResetPassAuthModal from '/react4xp/parts/block-auth/components/reset-pass-auth-modal';

const AuthForm: FC<any> = (props: any) => {
    const [sessionToken, setSessionToken] = useState<string>();
    const [signedData, setSignedData] = useState<string>();
    const [signType, setSignType] = useState('LOGIN');
    const [loginStep, setLoginStep] = useState(1);
    const [signing, setSigning] = useState(false);
    const [isOpenForgetPassModal, setOpenForgetPassModal] = useState(false);
    const [isOpenResetPassModal, setIsOpenResetPassModal] = useState(false);
    const [agreementChecked, setAgreementChecked] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const [form] = Form.useForm();

    useEffect(() => {
        if (props.params && props.params.register) {
            setSignType('SIGNUP');
        }
    }, []);

    const getToken = () => {
        return service.getToken().then((res: any) => {
            const xml = {
                data: `<body><text><registrationSessionToken>${
                    res.data
                    }</registrationSessionToken>${new Date()}</text></body>`,
            };
            setSessionToken(res.data);
            return xml;
        });
    };

    const onFinish = (values: any) => {
        setSigning(true);

        auth({
            action: 'login',
            signedData: btoa(unescape(encodeURIComponent(signedData))),
            ...values,
        })
            .then((value) => {
                if (value.data.access_token) {
                    Cookies.set('token', value.data.access_token, { path: '/', expires: 5 / 24 }); // 5 hours
                    Cookies.set('refresh_token', value.data.refresh_token, {
                        path: '/',
                        expires: 10 / 24,
                    }); // 10 hours

                    if (location.search) {
                        const queries = parseUrlQuery();
                        queries['redirect'] && open(queries['redirect'], '_self');
                    } else {
                        open(`/${props.lang}`, '_self');
                    }
                    localStorage.setItem('notificationAcquainted', 'false');
                    localStorage.removeItem('user-data');
                } else {
                    setSigning(false);

                    const { status, message, body } = value.data;

                    notification['error']({
                        message: `${status} - ${message}`,
                        description: JSON.stringify(body),
                    });
                }
            })
            .catch((error) => {
                if (
                    error.response.data &&
                    error.response.data.message &&
                    error.response.data.message === 'error.reset-password-action-required'
                ) {
                    // Если ошибка о смене пароля
                    // вызываем модальное окно для смены пароля
                    setIsOpenResetPassModal(true);
                }

                setSigning(false);
            });
    };

    const returnFirstStep = () => {
        setLoginStep(1);
        form.resetFields();
    };

    const openForgetPasswordModal = () => {
        setOpenForgetPassModal(true);
    };

    const closeForgetPasswordModal = () => {
        setOpenForgetPassModal(false);
    };

    const handleAgreementChange = (e) => {
        setAgreementChecked(e.target.checked);
    };

    const handleAccept = () => {
        setAgreementChecked(true);
        handleModalClose();
    };

    const openModalLink = () => {
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
    };

    const getDataAsJson = (data: any) => {
        if (typeof data == 'string') {
            return JSON.parse(data);
        }

        return data;
    };

    const handleSingedData = (signedData: string) => {
        getDataFromEcp(btoa(unescape(encodeURIComponent(signedData)))).then(({ data }) => {
            const iin = edsResultCheck(getDataAsJson(data), props.translations);

            if (iin) {
                form.setFieldValue('login', iin);
                setSignedData(signedData);
                // setLoginStep(2);

                setSigning(true);

                auth({
                    action: 'login',
                    signedData: btoa(unescape(encodeURIComponent(signedData))),
                    login: iin,
                })
                    .then((value) => {
                        if (value.data.access_token) {
                            Cookies.set('token', value.data.access_token, {
                                path: '/',
                                expires: 5 / 24,
                            }); // 5 hours
                            Cookies.set('refresh_token', value.data.refresh_token, {
                                path: '/',
                                expires: 10 / 24,
                            }); // 10 hours

                            if (location.search) {
                                const queries = parseUrlQuery();
                                queries['redirect'] && open(queries['redirect'], '_self');
                            } else {
                                open(`/${props.lang}`, '_self');
                            }
                            localStorage.setItem('notificationAcquainted', 'false');
                            localStorage.removeItem('user-data');
                        } else {
                            setSigning(false);

                            const { status, message, body } = value.data;

                            notification['error']({
                                message: `${status} - ${message}`,
                                description: JSON.stringify(body),
                            });
                        }
                    })
                    .catch((error) => {
                        if (
                            error.response.data &&
                            error.response.data.message &&
                            error.response.data.message === 'error.reset-password-action-required'
                        ) {
                            // Если ошибка о смене пароля
                            // вызываем модальное окно для смены пароля
                            setIsOpenResetPassModal(true);
                        }

                        setSigning(false);
                    });
            }
        });
    };

    const closeResetPassModal = () => {
        setIsOpenResetPassModal(false);
        form.resetFields(['password']);
    };

    return (
        <>
            {signType === 'LOGIN' ? (
                <Form
                    onFinish={onFinish}
                    form={form}
                    layout="vertical"
                >
                    <div className="block-auth__title">
                        {localize('block-auth-authorization', props.translations)}
                    </div>
                    <Row gutter={[24, 24]}>
                        {loginStep === 1 ? (
                            <>
                                <Col span={24}>
                                    <Signature
                                        onGetXml={getToken}
                                        onSubmit={handleSingedData}
                                        icon={true}
                                        loading={signing}
                                        translations={props.translations}
                                    />
                                </Col>
                                <Col span={24}>
                                    <div className="text-secondary">
                                        {localize('block-auth-select-an-eds', props.translations)}
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <Button onClick={() => setSignType('SIGNUP')}>
                                        {localize('block-auth-register', props.translations)}
                                    </Button>
                                </Col>
                            </>
                        ) : loginStep === 2 ? (
                            <>
                                <Col span={24}>
                                    <Alert
                                        message={
                                            <div>
                                                Внимание!{' '}
                                                <div>
                                                    После трёх неудачных попыток ваша учётная запись
                                                    будет заблокирована.
                                                </div>
                                            </div>
                                        }
                                        type="warning"
                                        showIcon
                                    />
                                </Col>

                                <Col span={24}>
                                    <Form.Item name="login">
                                        <Input
                                            placeholder={localize(
                                                'block-auth-login',
                                                props.translations
                                            )}
                                            disabled={true}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: localize(
                                                    'block-auth-required-field',
                                                    props.translations
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input.Password
                                            placeholder={localize(
                                                'block-auth-password',
                                                props.translations
                                            )}
                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <Checkbox
                                            checked={agreementChecked}
                                            onChange={handleAgreementChange}
                                        >
                                            {localize('familiar-accept', props.translations)}{' '}
                                            <a
                                                href="#"
                                                onClick={openModalLink}
                                            >
                                                {localize('user-agreement', props.translations)}
                                            </a>
                                        </Checkbox>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Button
                                        type="primary"
                                        color="gold"
                                        htmlType="submit"
                                        loading={signing}
                                        disabled={!agreementChecked}
                                    >
                                        {localize('block-auth-log-in', props.translations)}
                                    </Button>
                                </Col>
                                <Col span={24}>
                                    <Button onClick={() => returnFirstStep()}>
                                        {localize('cancel', props.translations)}
                                    </Button>
                                </Col>
                                <Col span={24}>
                                    <a
                                        onClick={() => setSignType('SIGNUP')}
                                        className="text-secondary"
                                    >
                                        {localize('block-auth-register', props.translations)}
                                    </a>
                                </Col>
                            </>
                        ) : null}
                        {/* <Col span={24}>
                            <a
                                onClick={openForgetPasswordModal}
                                className="text-secondary"
                            >
                                {localize('block-auth-lost-password', props.translations)}
                            </a>
                        </Col> */}
                    </Row>
                    <Modal
                        title={
                            <div style={{ textAlign: 'center' }}>
                                {localize('user-agreement', props.translations)}
                            </div>
                        }
                        open={modalVisible}
                        onCancel={handleModalClose}
                        footer={null}
                        width={1000}
                    >
                        <div dangerouslySetInnerHTML={{ __html: props.config.agreement }} />
                        <div
                            className="modal__button-container"
                            style={{ display: 'flex', justifyContent: 'flex-end' }}
                        >
                            <Button
                                type="primary"
                                color="gold"
                                onClick={handleAccept}
                            >
                                {localize('familiar-accept', props.translations)}
                            </Button>
                        </div>
                    </Modal>
                </Form>
            ) : null}

            {signType === 'SIGNUP' ? (
                <Row gutter={16}>
                    <Col span={24}>
                        <SignUpUser
                            getToken={getToken}
                            sessionToken={sessionToken}
                            icon={true}
                            setSignType={setSignType}
                            translations={props.translations}
                            language={props.language}
                        />
                    </Col>
                </Row>
            ) : null}

            <ForgetPassword
                open={isOpenForgetPassModal}
                close={closeForgetPasswordModal}
                translations={props.translations}
            />

            <ResetPassAuthModal
                open={isOpenResetPassModal}
                close={closeResetPassModal}
                signedData={btoa(unescape(encodeURIComponent(signedData)))}
                oldPassword={form.getFieldValue('password')}
                translations={props.translations}
            />
        </>
    );
};

export default AuthForm;
